export default "__VITE_ASSET__kkM$MuGO__"